import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Observable, catchError} from 'rxjs';
import {DataService} from '../data.service';
import {StateCountry, RateTypes, RatesHhgProcure, RatesHhgProcureUpdate} from '../../shared/common-components/common-structure';
import {RatesHhgProcureEdit} from '../../features/hhg-rate-edit/rateshhgprocureedit';


@Injectable({
  providedIn: 'root'
})

export class HhgRateEditService extends DataService {

  private baseURI = this.apiUri + '/statecountry/';
  private baseURIrates = this.apiUri + '/ratetypes/';
  private baseURIhhg = this.apiUri + '/hhgrates/';

  constructor(http: HttpClient) {
    super(http);
  }

  /*
    Purpose of this function is to get all states or countries
  */
  getStateCountry(statecountrytype: string): Observable<StateCountry[]> {
    this.setUri(this.baseURI + statecountrytype + '/statecountrytype');
    return this.get().pipe(catchError(this.handleError));

  }

  /*
   Purpose of this function is to get rates for a transportation types
 */
  getRates(businesstype: string, transportationtype: string): Observable<RateTypes[]> {
    this.setUri(this.baseURIrates);
    return this.get().pipe(catchError(this.handleError));

  }
   /*
   Purpose of this function is to get rates hhg procure
 */
  getAllRatesList(carrierId: string, ratesBidcyclesId: string,
                  sroMasterId: string,
                  originId: string, destinationId: string,
                  statusType: string): Observable<RatesHhgProcureEdit[]> {
    this.setUri(this.baseURIhhg + carrierId + '/carrierId/' +
      ratesBidcyclesId + '/ratesBidcyclesId/' +
      sroMasterId + '/sroMasterId/' +
      originId + '/originId/' +
      destinationId + '/destinationId/' +
      statusType + '/statusType');
    return this.get().pipe(catchError(this.handleError));
  }


  deleteRatesHhgProcure(procureIdArray: number[]): Observable<any> {
    this.setUri(this.baseURIhhg + 'deleteRatesHhg');
    return this.update(procureIdArray);
  }

  updateRatesHhgProcure(ratesHhgList: RatesHhgProcure[]): Observable<any> {
    this.setUri(this.baseURIhhg + 'updateRatesHhg');
    return this.update(ratesHhgList);
  }

    //update and validate exp bonds
    updateRatesHhgProcureWithValidateExpirationBonds(ratesHhgProcureUpdate: RatesHhgProcureUpdate): Observable<any> {
      this.setUri(this.baseURIhhg + 'updateRatesHhgWithBondsValidation');
      return this.update(ratesHhgProcureUpdate);
    }
    //end
}

